// Types
import type { components } from '@/types/schema'

// Redux
import { createSlice } from '@reduxjs/toolkit'

type PaymentNoticeSlice = {
  data: components['schemas']['PaymentNotice'][]
  active: components['schemas']['PaymentNotice'] | null
}

const initialState: PaymentNoticeSlice = {
  data: [],
  active: null,
}

const paymentNotices = createSlice({
  name: 'paymentNotices',
  initialState,
  reducers: {
    setPaymentNotices(state, action: { payload: components['schemas']['PaymentNotice'][] }) {
      state.data = action.payload
    },
    setActivePaymentNotice(state, action: { payload: components['schemas']['PaymentNotice'] | null }) {
      state.active = action.payload
    },
    addPaymentNotice(state, action: { payload: components['schemas']['PaymentNotice'] }) {
      state.data.push(action.payload)
    },
  },
})

export type TPaymentNoticeState = PaymentNoticeSlice

export default paymentNotices.reducer

export const { setPaymentNotices, setActivePaymentNotice, addPaymentNotice } = paymentNotices.actions
